import axiosInstance from "../utils/axiosInstance";

class UserApi {

  login(formValues){
    const apiUrl = "/web/users/sign_in.json";
    return axiosInstance.post(apiUrl, {user: formValues})
      .then(response => {
        const ok = response.status == 201;
        return Promise.resolve(ok);
      });
  }


  logout(){
    const apiUrl = "/web/users/sign_out";
    return axiosInstance.get(apiUrl)
      .then(response => {
        const ok = response.status == 200;
        return Promise.resolve(ok);
      });
  }

  forgotPassword(username: string){
    const apiUrl = "/web/users/password.json";
    return axiosInstance.post(apiUrl, {user: {username}})
      .then(response => {
        const ok = response.status == 201;
        return Promise.resolve(ok);
      });
  }

  resetPassword(passwordParams){
    const apiUrl = "/web/users/password.json";
    return axiosInstance.put(apiUrl, {user: passwordParams})
      .then(response => Promise.resolve(response))
      .catch(err => Promise.reject(err))
  }

}

export default new UserApi();